import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  status?: string | null;
  numero?: string | null;
  descricao?: string | null;
};
type Actions = {
  setStatus: (status: string | null) => void;
  setNumero: (numero: string | null) => void;
  setDescricao: (descricao: string | null) => void;
  clear: () => void;
};

export const useFilters = create<State & Actions>((set) => ({
  status: "A",
  numero: null,
  descricao: null,
  setStatus: (status) => set({ status }),
  setNumero: (numero) => set({ numero }),
  setDescricao: (descricao) => set({ descricao }),
  clear: () => set({ status: "T", numero: null, descricao: null }),
}));
